import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import ScienceClubSideBar from '../ScienceClubSideBar';
import Sidebar2026 from '../ScienceClub/Sidebar2026';

const ScienceAssociation_9to12_2026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/Senior/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/Senior/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/Senior/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/Senior/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/Senior/5.webp`;
    const p6 = `${config.base_image_url_2026}/home/events-activities/association/ScienceClub/Senior/6.webp`;


    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p6,
            source: p6,
            rows: 1.5,
            cols: 1,
        }
    ];

    return (
        <Main>

            <Container>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
                                <Typography variant='h5' align='center' >
                                   Activity: The Science Chronicle - Science News Bulletin
                                </Typography>
                                <br />
                                <Typography
                                    fontSize="x-small"
                                > <br />
                                    Classes- 9 to 12   Date: 13 August 2026
                                </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
On 13th August 2026, the Senior Science Association organised an engaging inter-house activity
titled <strong>‘The Science Chronicle - Science News Bulletin’</strong>. The event was designed to fuse
journalistic flair with analytical thinking. The event challenged students to demonstrate the
modern scientific developments and to interconnect manifestations of fundamental principles.
A team of four ‘reporters’ from each house delivered a distinct, fast-paced news bulletin on a
specific scientific breakthrough. The students re-engaged themselves to present their
interconnected panel, proving how their four technologies offer a scope of interdisciplinary
development highlighting the collaborative nature of modern scientific innovation and its
impact on society. The competition pushed students beyond surface-level rote knowledge into
high-level conceptual integration. Participants were evaluated on reporting skills, scientific
accuracy, the clarity of their unifying scientific rationale and the feasibility of their real-world
applications. The Senior Science Association commends all students for demonstrating
exceptional team coordination and scientific communication skills..
                                <br />
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
‘Translating the complex language of the universe into the story of today.’
                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                            <Sidebar2026 />
                        </Box>
                        <Box marginBottom={4}>
                            <ScienceClubSideBar />

                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default ScienceAssociation_9to12_2026;